export default "__VITE_ASSET__iMXqnCr4coUxBI5W$nqJZA__";